import { render, staticRenderFns } from "./RatingTable.vue?vue&type=template&id=4ddad711&scoped=true&lang=html"
import script from "./RatingTable.vue?vue&type=script&lang=js"
export * from "./RatingTable.vue?vue&type=script&lang=js"
import style0 from "./RatingTable.vue?vue&type=style&index=0&id=4ddad711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddad711",
  null
  
)

export default component.exports